import React from "react";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { i18n } from "../../translate/i18n";

const TicketsQueueSelect = ({
  userQueues = [],
  selectedQueueIds = [],
  onChange,
}) => {
  const value = (userQueues || []).filter((q) =>
    selectedQueueIds.includes(q.id)
  );

  const handleChange = (_event, next) => {
    onChange((next || []).map((q) => q.id));
  };

  return (
    <Autocomplete
      multiple
      size="small"
      options={userQueues || []}
      value={value}
      onChange={handleChange}
      getOptionLabel={(option) => option?.name || ""}
      getOptionSelected={(option, val) => option?.id === val?.id}
      renderTags={() => null}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder={i18n.t("ticketsQueueSelect.placeholder")}
        />
      )}
    />
  );
};

export default TicketsQueueSelect;
